import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';
import { initialiserTheme } from './theme';

// Avant le premier rendu, pour eviter un eclair de fond clair au demarrage.
initialiserTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
